// extracted by mini-css-extract-plugin
export var banner = "_1f-0";
export var icon = "_1f-1";
export var message = "_1f-2";